/* global ym */
import Vue from 'vue';
import FunctionbarMobile from '@/components/FunctionbarEcommerce/FunctionbarMobile';
import FunctionbarDesktop from '@/components/FunctionbarEcommerce/FunctionbarDesktop';
import EcommerceMapView from '../../components/EcommerceMap/EcommerceMapView.vue';
import loadYmaps from '../../helpers/ymaps-loader';
import FormCooperationEcommerce from "../../components/FormCooperationEcommerce/FormCooperationEcommerce";
import FormbarCitySuggest from "@/components/ComponentsForm/FormbarCitySuggest";
import { listenToStartSearchTrackEvent as initTrackWidgetModal } from '../../components/TrackingWidget/TrackWidgetModal.vue';
import SchemeWorkSlider from '../../components/SchemeWork/SchemeWorkSlider.vue';
import EcommerceListenAnchor from "../../components/Ecommerce/EcommerceListenAnchor";
import { factory as initMobileHeaderMenu } from '../../components/MobileHeaderMenu/MobileHeaderMenu.vue';
import { targetsYmOnAdvantages } from '../../helpers/targets-ym';
import { factory as personalAccountButtonFactory } from '../../components/PersonalAccountChoiceModal/PersonalAccountButton.vue';
import BbRequesForm from '../../components/RequesForm/BbRequesForm.vue'

import VueFactory from '../../helpers/vueFactory';
import initApplicationGlobal from '../Global/Global';

export default function initEcommercePage(eventHub) {
  initApplicationGlobal(eventHub);

  try {
    // eslint-disable-next-line no-undef
    $(document).ready(function(){
      // eslint-disable-next-line no-undef
      $('.reviews-slider-mobile').slick({
        dots: true,
        arrows: false,
      });
    });
  } catch (e) {
    console.error(e)
  }

  if (document.getElementById('form-e-commerce')) {
    VueFactory(BbRequesForm, {
      el: '#form-e-commerce',
    }, {}, {
      capthcaKey: '6LcnpgEVAAAAABw1FJIJI8etqfPdtOrb8-ZADgfo',
      title: 'Регистрация',
      sendUrl: '/form/join',
      citieListApiUrl: 'https://boxberry.ru/api/v1/cities/list',
      lsNameItem: 'citiesList',
    });
  }

  if (document.querySelector('.form[data-type="join"]')) {
    VueFactory(FormCooperationEcommerce, {
      el: '.form[data-type="join"]',
      created() {
        document.addEventListener('submit-success', (event) => {
          if (event.detail.form.dataset.type === 'join' && typeof ym !== 'undefined') {
            ym(57872296, 'reachGoal', 'ecomerce_reg');
          }
        });
      },
    });
  }

  if (document.querySelector('.form[data-type="mim-sng"]')) {
    VueFactory(FormCooperationEcommerce, {
      el: '.form[data-type="mim-sng"]',
      created() {
        document.addEventListener('submit-success', (event) => {
          if (event.detail.form.dataset.type === 'join' && typeof ym !== 'undefined') {
            ym(57872296, 'reachGoal', 'ecomerce_reg');
          }
        });
      },
    }, {}, { formType: 'join' });
  }

  const ecommerceMapEl = document.querySelector('#ecommerceMap');
  if (ecommerceMapEl) {
    const params = {};
    const {  newDesign = false } = ecommerceMapEl.dataset;
    if (newDesign) {
      params.newDesign = !!newDesign;
    }
    loadYmaps().then(() => {
      VueFactory(EcommerceMapView, {
        el: '#ecommerceMap',
      }, {}, {
        ...params,
      });
    });
  }

  initTrackWidgetModal();

  if (eventHub && eventHub.mountFunctionBar) {
    if (window.innerWidth < 580 && document.querySelector('.functionbar-mobile')) {
      VueFactory(FunctionbarMobile, {
        el: '.functionbar-mobile',
      });
    }

    if (document.querySelector('.function-bar')) {
      VueFactory(FunctionbarDesktop, {
        el: '.function-bar',
      });
    }
  }

  if (document.querySelector('#calcFrom')) {
    VueFactory(FormbarCitySuggest, {
      el: '#calcFrom',
      data: {
        nameField: 'calcImFrom',
        filtered: 'Reception',
      },
    });
  }


  if (document.querySelector('#calcTo')) {
    VueFactory(FormbarCitySuggest, {
      el: '#calcTo',
      data: {
        nameField: 'calcImTo',
        filtered: 'Pickup_point',
      },
    });
  }

  new Vue(SchemeWorkSlider);
  new Vue({
    ...EcommerceListenAnchor,
    propsData: {
      scrolledToAnchor: window.location.hash === '#form_ecom',
      ecommerceHomePage: window.location.pathname.match(/^\/e-commerce\/?$/i)
        || window.location.pathname.match(/^\/e-commerce\/uslugi\/dostavka-v-kazahstan-i-belarus\/?$/i),
    },
  });

  initMobileHeaderMenu({
    subMenuCalc: false,
    subpage: window.location.pathname !== '/e-commerce',
    scrollToCalcIM: window.location.hash === '#calcIM',
  });

  const arrayIdTargets = ['mim_block_lk', 'mim_block_connect', 'mim_block_taking_orders', 'mim_block_cooperation', 'mim_block_support'];

  targetsYmOnAdvantages(arrayIdTargets);

  personalAccountButtonFactory({
    classModifier: 'button-accounts_header-desktop',
    restorePopupMode: 'desktop',
  });
}
